/** 营销中心 */

// 基础路径判断
let protocol = window.location.protocol; // 协议
// 测试环境，域名的时候 http://cmms2.midea.com/
let baseApi = process.env.BASE_API;
let prefixMeiju = "/dcpServiceOpmange/supervisor";
if (window.location.href.indexOf("://cmms2") >= 0) {
  baseApi = "http://cmms2.midea.com/";
}
if (protocol === "https:") {
  baseApi = baseApi.replace("http:", "https:");
}
/** 积分兑换 */
// 积分兑换订单列表
export const EXCHANGE_ORDER_LIST = "/cmvip/exchangeGoods/orderList";
// 积分兑换订单详情
export const EXCHANGE_ORDER_DETAIL = "/cmvip/exchangeGoods/orderDetail";
// 修改积分兑换商品状态
export const UPDATE_GOODS_STATUS = "/cmvip/exchangeGoods/updateGoodsStatus";
// 积分兑换变更订单状态（取消或发货）
export const EXCHANGE_CHANGE_ORDER_STATUS =
  "/cmvip/exchangeGoods/changeOrderStatus";
// 获取物流公司接口
export const EXCHANGE_LOGINSTICS_LIST =
  "/cmvip/exchangeGoods/getExchangeLogisticsList";
// 导出兑换订单模板
export const EXCHANGE_TEMPLET_EXOPRT =
  "/cmvip/templet/%E6%89%B9%E9%87%8F%E6%9B%B4%E6%94%B9%E8%AE%A2%E5%8D%95%E7%8A%B6%E6%80%81%E6%A8%A1%E6%9D%BF.xlsx";
// 导入兑换订单
export const EXCHANGE_BATCH_CHANGE_STATUS =
  "/cmvip/exchangeGoods/batchChangeOrderStatus";
// 导出
export const EXCHANGE_EXCHANGE_ORDER =
  "/cmvip/exchangeGoods/exportExchangeOrder";
// 积分兑换商品列表
export const EXCHANGE_GOODS_LIST = "/cmvip/exchangeGoods/goodsList";
// 新建积分兑换商品
export const ADD_EXCHANGE_GOODS = "/cmvip/exchangeGoods/addExchangeGoods";
// 积分兑换商品详情
export const GOODS_DETAIL = "/cmvip/exchangeGoods/goodsDetail";
// 修改积分兑换商品
export const UPDATE_EXCHANGE_GOODS = "/cmvip/exchangeGoods/updateExchangeGoods";
// 第三方商品列表
export const EXCHANGE_GIFTS_LIST = "/cmvip/exchangeGoods/theirGoodsList";
// 导入券码
export const EXCHANGE_COUPON_UPLOAD =
  baseApi + "/cmvip/exchangeGoods/uploadCoupon";
// 修改积分兑换商品状态-批量修改
export const UPDATE_GOODS_STATUS_BATCH = "/cmvip/exchangeGoods/batchAudit";
// 兑换列表-批量导入
export const EXCHANGE_GOODS_LIST_UPLOAD =
  baseApi + "/cmvip/exchangeGoods/upload";

/** 广告投放 */
// 新建-提交/暂存广告信息
export const CMAD_EDITAD_NEWAD = "/cmad/editAd/newAd";
// 编辑-提交/暂存广告信息
export const CMAD_EDITAD_EDITAD = "/cmad/editAd/editAd";
// 最终提交表单
export const CMAD_EDITAD_SUBMITAD = "/cmad/editAd/submitAd";
// 投放渠道和抵达位置
export const DD_VALUE_BY_KEY = "/cmad/ddValueManage/queryDDValueByKey";
// 投放渠道和抵达位置
export const COM_BO_DATA = "/cmms/common/comboData?type=wxmpTypeBrand1";
// 广告列表
export const DD_VALUE_GET_AD_LIST = "/cmad/adList/getAdList";
// 获取单条广告详情
export const CMAD_GET_AD_DETAIL = "/cmad/adList/getAdDetail";
// 删除广告
export const CMAD_DELETE_AD = "/cmad/adList/deleteAd";
// 广告启用/禁用
export const CMAD_UPDATE_AD_STATUS = "/cmad/adList/updateAdStatus";
// 根据展示位置查询广告详情
export const CMAD_GET_AD_DETAIL_BY_POSITION =
  "/cmad/adList/getAdByBrandAndTpId";
// 广告banner启用/禁用
export const CMAD_UPDATE_BANNER_STATUS = "/cmad/editAd/updateBannerStatus";
// 广告banner物理删除
export const CMAD_DELETE_BANNER = "/cmad/editAd/deleteBrannerById";

/** 新品试用 */
// 新品试用活动列表
export const PRODUCT_ACTIVITY_LIST = "/cmvip/productActivity/list";
// 新品试用活动列表(midea)
export const PRODUCT_ACTIVITY_LIST_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/searchNewGoodsList";
// 新品试用活动发布
export const PRODUCT_ACTIVITY_INTRODUCED = "/cmvip/productActivity/introduced";
// 新品试用活动发布(midea)
export const PRODUCT_ACTIVITY_PUBLISH_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/publishActivity";
// 新品试用活动停用(midea)
export const PRODUCT_ACTIVITY_STOP_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/downActivity";
// 新品试用活动详情
export const PRODUCT_ACTIVITY_DETAIL = "/cmvip/productActivity/getById";
// 新品试用活动详情(midea)
export const PRODUCT_ACTIVITY_DETAIL_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/getById";
// 新增新品试用活动
export const PRODUCT_ACTIVITY_SAVE = "/cmvip/productActivity/save";
// 新增/编辑新品试用活动(midea)
export const PRODUCT_ACTIVITY_SAVE_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/save";
// 新品试用活动删除
export const PRODUCT_ACTIVITY_DELETED = "/cmvip/productActivity/deleted";
// 新品试用活动删除
export const PRODUCT_ACTIVITY_DELETED_MIDEA =
  "/dcpServiceOpmange/supervisor/newGoods/remove";

// 编辑新品试用活动
export const PRODUCT_ACTIVITY_UPDATE = "/cmvip/productActivity/update";
// 新品试用订单列表
export const PRODUCT_ORDER_LIST = "/cmvip/productOrder/list";
// 新品试用订单发货
export const PRODUCT_ORDER_DELIVER = "/cmvip/productOrder/deliver";
// 新品试用订单填写评测内容
export const PRODUCT_ORDER_EVALUATE = "/cmvip/productOrder/evaluate";
// 新品试用订单编辑评测内容
export const PRODUCT_ORDER_EVALUATE_EDIT =
  "/cmvip/productActivity/reportUpdate";
// 新品试用报告-订单
export const PRODUCT_PRODUCT_ACTIVITY_REPORT = "/cmvip/productActivity/report";
// 新品试用订单评价
export const PRODUCT_ORDER_EXAMINE = "/cmvip/productOrder/examine";
// 新品试用订单问题详情
export const PRODUCT_ORDER_GET_QUESTION_BY_ID = "/cmvip/productOrder/getById";
// 新品试用报告-删除
export const PRODUCT_ACTIVITY_REPORE_DELLETED =
  "/cmvip/productActivity/reportDeleted";
// 新品试用报告详情
export const PRODUCT_ACTIVITY_REPORE_GET_BY_ID =
  "/cmvip/productActivity/reportGetById";

/** 短链管理 */
// 短链列表
export const GET_SHORT_LINK_LIST = "/cmsms-new/link/list";
// 短链新增/编辑
export const SHORT_LINK_SAVE = "/cmsms-new/link/saveOrUpdate";
// 短链删除
export const SHORT_LINK_DELETE = "/cmsms-new/link/delete";
// 短链详情
export const SHORT_LINK_DETAIL = "/cmsms-new/link/detail";
// PV/UV看板-短链/广告
export const PVUV_DATA_LIST = "/ccrm2/da/event/getChartPvUvByRow";
// PV/UV总数
export const PVUV_DATA_TOTAL = "/ccrm2/da/event/getTotalPvUvByRow";
// 分组获取短链、广告等事件pvuv总数
export const EVENT_GET_PV_UV_WITH_GROUP_BY =
  "/ccrm2/da/event/getPvUvWithGroupBy";

/** 短信管理 */
// 获取短信列表
export const SMS_ACTIVITY_EVENTS = "/cmsms-new/sms/list";
// 删除为投放的短信
export const SMS_DELETE_BY_ID = "/cmsms-new/sms/delete";
// 获取单条短信详情
export const GET_EVENT_DETAIL = "/cmsms-new/sms/detail";
// 获取短信的发送主题
export const SMS_GET_ORG_MSG = "/cmsms-new/sms/getOrgMsg";
// 测试短信发送
export const SMS_TEST_SMS = "/cmsms-new/sms/testSms";
// 上传用户文件
export const SMS_UPLOAD_USER_FOR_BATCH = baseApi + "/cmsms-new/sms/upload";
// 新建/编辑短信
export const SMS_CONFIG = "/cmsms-new/sms/saveOrUpdate";
// 失败短信导出
export const SMS_FAILED_EXPORT = "/cmsms-new/sms/download";
// 人群包列表
export const SMS_BIG_DATA_GROUP_LIST = "/cmsms-new/sms/bigData/groupList";
// 获取预览时人群包变量
export const SMS_FIRST_MOBILE = "/cmsms-new/sms/firstMobile";
// 中止短信接口
export const SMS_STOP_SEND_TASK_INFO = "/cmsms-new/template/stopSendTaskInfo";

/** 短信模板 */
// 模板列表查询
export const CMSMS_NEW_TEMPLATE_LIST = "/cmsms-new/template/list";
// 模板新增或编辑
export const CMSMS_NEW_TEMPLATE_SAVE_OR_UPDATE =
  "/cmsms-new/template/saveOrUpdate";
// 模板详情
export const CMSMS_NEW_TEMPLATE_DETAIL = "/cmsms-new/template/detail";
// 删除模板
export const CMSMS_NEW_TEMPLATE_DELETE = "/cmsms-new/template/delete";
// 变量列表
export const CMSMS_NEW_TEMPLATE_VARIABLE_LIST =
  "/cmsms-new/template/variableList";

/** 消息中心 */
// 消息中心列表
export const MSG_CENTER_LIST = "/cmmessage/newPlatform/query";
// 投放渠道
export const MSG_CHANNEL_LIST = "/cmmessage/message/getServiceAccount";
// 新建消息
export const MSG_CENTER_CREATE = "/cmmessage/newPlatform/saveMessage";
// 编辑消息
export const MSG_CENTER_EDIT = "/cmmessage/newPlatform/editMessage";
// 发送消息
export const MSG_CENTER_SEND = "/cmmessage/newPlatform/sendMessage/";
// 删除消息
export const MSG_CENTER_DELETE = "/cmmessage/newPlatform/deleteMessage/";
// 详情
export const MSG_CENTER_DETAIL = "/cmmessage/newPlatform/queryDetail/";

/** 优惠券管理 */
// 优惠券规则列表
export const COUPON_RULE_LIST = "/cmvip/coupon/couponList";
// 优惠券规则详情
export const COUPON_RULE_DETAIL = "/cmvip/coupon/couponDetail";
// 新增优惠券规则
export const COUPON_RULE_ADD = "/cmvip/coupon/addCoupon";
// 新增优惠券规则 - 上传图片的修改
export const COUPON_RULE_OPT_ADD = "/cmvip/coupon/optAddCoupon";
// 编辑优惠券规则
export const COUPON_RULE_EDIT = "/cmvip/coupon/updateCoupon";
// 编辑优惠券规则 - 上传图片的修改
export const COUPON_RULE_OPT_EDIT = "/cmvip/coupon/optUpdateCoupon";
// 批量导入
export const COUPON_RULE_UPLOAD = baseApi + "/cmvip/coupon/uploadCoupon";
// 优惠券规则-导出券码
export const COUPON_RULE_EXPORT = "/cmvip/couponCode/export";
// 优惠券发放-列表
export const COUPON_ACTIVITY_LIST = "/cmvip/couponActivity/list";
// 优惠券发放-启用/停用
export const COUPON_ACTIVITY_ENABLE = "/cmvip/couponActivity/introduced";
// 优惠券发放-详情
export const COUPON_ACTIVITY_DETAIL = "/cmvip/couponActivity/getById";
// 优惠券发放-新增
export const COUPON_ACTIVITY_ADD = "/cmvip/couponActivity/save";
// 优惠券发放-编辑
export const COUPON_ACTIVITY_EDIT = "/cmvip/couponActivity/update";
// 优惠券流水-列表
export const COUPON_ORDER_LIST = "/cmvip/couponActivity/getCouponOrderList";
// 优惠券流水-发货
export const COUPON_ORDER_SEND = "/cmvip/couponActivity/couponOrderSend";
// 优惠券流水-详情
export const COUPON_ORDER_DETAIL = "/cmvip/couponActivity/getCouponOrderById";
// 优惠券流水-导出
export const COUPON_ORDER_EXPORT = "/cmvip/coupon/exportCouponOrder";
// 优惠券流水-批量发货
export const COUPON_ORDER_UPLOAD =
  baseApi + "/cmvip/coupon/batchChangeOrderStatus";
// 优惠券流水-作废
export const COUPON_CANCEL_TO_VOID = "/cmvip/couponActivity/couponCancel";

/** 微信模板通知 */
// 查询保养配置列表
export const GET_UPKEEP_CONFIG_LIST =
  "/ccrm2-core/upKeepApi/getUpkeepConfigList";

/** 受众管理 */
// 查询受众人群管理列表
export const GET_AUDIENCE_LABEL_LIST = "/ccrm2/label/selectLabelList";
// 新增编辑标签
export const INSERT_OR_UPDATE_LABEL_INFO =
  "/ccrm2/label/insertOrUpdateLabelInfo";
// 查询标签详情
export const GET_LABEL_INFO = "/ccrm2/label/getLabelInfo";
// 删除标签
export const DELETE_LABEL_INFO = "/ccrm2/label/deleteLabelInfo";
/** 受众人群详情报表 */
// 人群数量趋势
export const LABEL_BOARD_TREND = "/ccrm2/labelBoard/trend";
// 人群明细
export const LABEL_BOARD_LIST = "/ccrm2/labelBoard/list";
// 来源人群分布
export const LABEL_BOARD_SOURCE_DISTRIIBUTED =
  "/ccrm2/labelBoard/sourceDistributed";
// 等级人群分布
export const LABEL_BOARD_LEVEL_DISTRIBUTED =
  "/ccrm2/labelBoard/levelDistributed";
// 获取活动平台游戏列表
export const PRECISION_PROMOTE_GET_CMIMP_GAME_LIST =
  "/ccrm2/promote/precisionPromote/getCmimpGameList";
// 洗悦家产品大类接口
export const SUPPORT_GET_PRODUCT_TYPE_XYJ = "/ccrm2/support/getProductTypeXyj";
/** 引用大数据人群 */
// 大数据人群列表
export const LABEL_SELECT_ODS_GROUP_LIST = "/ccrm2/label/selectOdsGroupList";
// 引用大数据人群
export const LABEL_SYNE_ODS_GROUP = "/ccrm2/label/syncOdsGroup";

/** 投放效果报表 */
// 详情页 - 概况
export const PROMOTE_BOARD_OVERVIEW = "/ccrm2/promote/board/overview";
// 根据appId获取漏斗事件树
export const FUNNEL_GET_EVENT_TREE = "/ccrm2/da/funnel/getEventTree";
// 根据appId获取漏斗步骤
export const FUNNEL_GET_STEPS = "/ccrm2/da/funnel/getFunnelSteps";
// 保存漏斗设置
export const PROMOTE_FUNNEL_SETTING_SAVE = "/ccrm2/promote/funnelSetting/save";
// 删除漏斗设置
export const PROMOTE_FUNNEL_SETTING_DELETE =
  "/ccrm2/promote/funnelSetting/delete";
// 根据prid获取设置的漏斗列表
export const PROMOTE_FUNNEL_SETTING_LIST = "/ccrm2/promote/funnelSetting/list";
// 获取漏斗转化率
export const PROMOTE_BOARD_FUNNEL_CONVER_SION_RATE =
  "/ccrm2/promote/board/funnelConversionRate";
// 获取漏斗趋势折线图
export const PROMOTE_BOARD_FUNNEL_TENDENCY =
  "/ccrm2/promote/board/funnelTendency";
// 总览概况
export const PROMOTE_BOARD_ALL_OVER_VIEW = "/ccrm2/promote/board/allOverview";
// 总览概况-折线图
export const PROMOTE_BOARD_ALL_OVERVIEW_CHART =
  "/ccrm2/promote/board/allOverviewChart";
// 获取投放任务分页列表
export const PROMOTE_TASK_PAGE = "/ccrm2/promote/task/page";
// 获取页面关联的事件列表
export const DA_EVENT_GET_EVENTS = "/ccrm2/da/event/getEvents";

/** 精准投放管理 */
// 获取精确投放列表数据-分页
export const PROMOTE_PRECISION_PROMOTE_PAGE =
  "/ccrm2/promote/precisionPromote/page";
// 获取精确投放列表数据
export const PROMOTE_PRECISION_PROMOTE_LIST =
  "/ccrm2/promote/precisionPromote/list";
// 获取精确投放详情
export const PROMOTE_PRECISION_PROMOTE_DETAIL =
  "/ccrm2/promote/precisionPromote/detail";
// 新增精准投放
export const PROMOTE_PRECISION_PROMOTE_ADD =
  "/ccrm2/promote/precisionPromote/add";
// 修改精准投放
export const PROMOTE_PRECISION_PROMOTE_UPDATE =
  "/ccrm2/promote/precisionPromote/update";
// 修改精准投放
export const PROMOTE_PRECISION_PROMOTE_DELETE =
  "/ccrm2/promote/precisionPromote/delete";
// 根据进准投放ID获取关联的渠道
export const PROMOTE_PRECISION_GET_CHANNEL =
  "/ccrm2/promote/precisionPromote/getChannelsByPrid";
// 根据进准投放ID获取关联的渠道
export const GET_PRECISION_AD_LIST =
  "/dcpServiceOpmange/supervisor/adList/getPrecisionAdList";
// 获取预计标签投放人数
export const PROMOTE_PRECISION_GET_PREDICT_LABEL_COUNT =
  "/ccrm2/promote/precisionPromote/getPredictLabelCount";
// 获取预计开始投放时间
export const PROMOTE_REECISION_GET_PREDICT_BEGIN_TIME =
  "/ccrm2/promote/precisionPromote/getPredictBeginTime";
// 投放人群标签查询(只查询投放过的标签)
export const SELECT_PROMOTE_LABEL =
  "/ccrm2/promote/precisionPromote/selectPromoteLabel";

/** 自动化营销策略 */
// 获取48小时推送素材列表
export const WCP_MSG_GET_MATERIAL_LIST = "/ccrm2/wcp/msg/getMaterialList";
// 精准投放启用/停用
export const PROMOTE_PRECISION_PROMOTE_UPDATE_ENABLE_STATE =
  "/ccrm2/promote/precisionPromote/updateEnableState";
// 获取触达人群总数
export const PROMOTE_BOARD_GET_ACHIEVE_TOTAL_NUM =
  "/ccrm2/promote/board/getAchieveTotalNum";
// 获取触达人群趋势折线图
export const PROMOTE_BOARD_GET_ACHIEVE_CHART_LINE =
  "/ccrm2/promote/board/getAchieveChartLine";
// 新增或修改标签组
export const LABEL_INSERT_OR_UPDATE_LABEL_TYPE =
  "/ccrm2/label/insertOrUpdateLabelType";
// 根据内容id查询标签列表
export const LABEL_GET_LABEL_TYPE_RELATION =
  "/ccrm2/label/selectLabelRelationList";
// 查询标签列表
export const LABEL_SELECT_LABEL_TYPE_LIST = "/ccrm2/label/selectLabelTypeList";
// 删除标签组
export const LABEL_DELETE_LABEL_TYPE = "/ccrm2/label/deleteLabelType";
// 绑定标签到内容
export const LABEL_INDSERT_OR_UPDATE_LABEL_RELATION =
  "/ccrm2/label/insertOrUpdateLabelRelation";
// 取模板消息模板列表
export const MSG_GET_TEMPLATE_LIST = "/ccrm2/wcp/msg/getTemplateList";
// 新增主从精准投放策略
export const PRECISION_PROMOTE_ADD_MASTER_SLAVE_RULE =
  "/ccrm2/promote/precisionPromote/addMasterSlaveRule";

/** 图文专题 */
// 获取图文专题列表
export const PIC_TOPIC_LIST = "/cmmessage/pictureTopic/page";
// 新增图文
export const PIC_TOPIC_ADD = "/cmmessage/pictureTopic/add";
// 编辑图文
export const PIC_TOPIC_UPDATE = "/cmmessage/pictureTopic/update";
// 图文启用/禁用
export const PIC_TOPIC_STATUS_UPDATE =
  "/cmmessage/pictureTopic/updateEnableStatus";
// 图文详情
export const PIC_TOPIC_DETAIL = "/cmmessage/pictureTopic/detail";
// 图文专题-图片上传
// export const UPLOAD_IMG_CMMESSAGE = baseApi + '/cmvip/uploadApi/directUploadToOss?type=pictureTopic';
export const UPLOAD_IMG_CMMESSAGE =
  (process.env.ENV_CONFIG === "dev" ? "/test" : "") +
  prefixMeiju +
  "/post/upload";

// 消息中心-保存图片
export const UPLOAD_IMG_SAVE = "/cmmessage/pics/save";
// 分页素材
export const PICTURE_TOPIC_MATERIALS_PAGE =
  "/cmmessage/pictureTopic/materialsPage";
// 删除素材
export const PICTURE_TOPIC_DELETE_MATERIAL =
  "/cmmessage/pictureTopic/deleteMaterial";
// 删除素材分类
export const PICTURE_TOPIC_DELETE_MATERIAL_TYPE =
  "/cmmessage/pictureTopic/deleteMaterialType";
// 新增/编辑素材
export const PICTURE_TOPIC_EDIT_MATERIAL =
  "/cmmessage/pictureTopic/editMaterial";
// 改素材分类名称
export const PICTURE_TOPIC_EDIT_MATERIAL_TYPE =
  "/cmmessage/pictureTopic/editMaterialType";
// mip审核流程的src地址
export const MIP_AUDIT_PROCESS_URL =
  process.env.ENV_CONFIG === "prod"
    ? "http://iflow.midea.com/iflow.html?fdrouter=/processForm/view/"
    : process.env.ENV_CONFIG === "uat"
    ? "http://iflowuat.midea.com/mse/iflow.html?fdrouter=/processForm/view/"
    : "http://iflowsit.midea.com/mse/iflow.html?fdrouter=/processForm/view/";

/** 数据中控平台接口 */
/** 推送管理 */
// 保存推送信息至草稿状态
export const SAVE_PUSH_MSG_URL = prefixMeiju + "/pushMsg/savePushMsg";
export const UPDATE_PUSH_MSG_URL = prefixMeiju + "/pushMsg/updatePushMsg";

// 提交推送信息
// 新增页提交
export const COMMIT_PUSH_MSG_ADD_URL =
  prefixMeiju + "/taskmipflowlist/pushaddcreateandsendmipinfo";
// 编辑页提交
export const COMMIT_PUSH_MSG_EDIT_URL =
  prefixMeiju + "/taskmipflowlist/pushadtcreateandsendmipinfo";
// 获取推送预计人数
export const PUSH_USER_COUNT_URL =
  prefixMeiju + "/taskmipflowlist/pushUserCount";
// 保存推送审核人
export const SAVA_TARGET_AUDITOR_URL =
  prefixMeiju + "/taskmipflowlist/savatargetauditor";
// 删除推送信息
export const DELETE_PUSH_MSG_URL = prefixMeiju + "/pushMsg/deletePushMsg";
// 作废推送信息
export const INVALID_PUSH_MSG_URL = prefixMeiju + "/pushMsg/invalidPushMsg";
// 推送信息列表
export const LIST_PUSH_MSG_URL = prefixMeiju + "/pushMsg/listPushMsg";
// 获取推送信息
export const GET_PUSH_MSG_URL = prefixMeiju + "/pushMsg/getPushMsg";
// 推送活动消息预览
export const PUSH_APP_MSG_URL = prefixMeiju + "/pushMsg/pushMessagePreview";
export const PUSH_APP_MSG_EDIT_URL =
  prefixMeiju + "/pushMsg/pushMessagePreviewEdit";
// 获取用户标签
export const USER_GROUP_LIST_URL =
  prefixMeiju + "/taskmipflowlist/userGroupList";
// 同步用户标签 新增页
export const LOAD_TAG_USER_ADD_URL =
  prefixMeiju + "/taskmipflowlist/pushaddsendsynuserinfos";
// 同步用户标签 编辑页
export const LOAD_TAG_USER_EDIT_URL =
  prefixMeiju + "/taskmipflowlist/pushadtsendsynuserinfos";
// 推送用户id文件 上传
export const UPLOAD_PUSH_USER_ID =
  baseApi + "dcpServiceOpmange/supervisor/pushMsg/upload";

/** 广告位管理 */
// 广告位新增
export const ADV_POSITION_ADD_URL = prefixMeiju + "/adPosition/addPos";
// 保存推送审核人
export const SAVA_TARGET_GG_AUDITOR_URL =
  prefixMeiju + "/taskmipflowlist/savaggtargetauditor";
// 广告位删除
export const ADV_POSITION_DELETE_URL = prefixMeiju + "/adPosition/deletePos";
// 广告位编辑
export const ADV_POSITION_UPDATE_URL = prefixMeiju + "/adPosition/updatePos";
// 广告位列表
export const ADV_POSITION_LIST_URL = prefixMeiju + "/adPosition/check";
// 广告位列表查询
export const QUERY_ADV_POS_URL = prefixMeiju + "/adPosition/getPos";
// 获取广告位详情
export const GET_ADV_POS_DETAIL_URL = prefixMeiju + "/adPosition/getById";

/** 广告管理 */
// 广告新增
export const ADV_ADD_URL = prefixMeiju + "/advertisement/addAd";
// 广告删除
export const ADV_DELETE_URL = prefixMeiju + "/advertisement/deleteAd";
// 广告编辑
export const ADV_UPDATE_URL = prefixMeiju + "/advertisement/updateAd";
// 修改排序
export const ADV_UPDATE_WEIGHT_URL =
  prefixMeiju + "/advertisement/updateAdWeight";
// 广告预览
export const DIRECTIONAL_TO_MOBILE =
  prefixMeiju + "/advertisement/directionalToMobile";
// 更新记录
export const GET_UPDATED_LOG =
  prefixMeiju + "/advertisement/getOnlineAdvertisementLatestChangeRecord";
// 复制广告
export const ADVERTISEMENT_COPY =
  prefixMeiju + "/advertisement/copyAdvertisement";
// 广告审核 新增
export const COMMIT_ADV_MSG_ADD_URL =
  prefixMeiju + "/taskmipflowlist/ggaddcreateandsendmipinfo";
// 广告审核 编辑
export const COMMIT_ADV_MSG_EDIT_URL =
  prefixMeiju + "/taskmipflowlist/ggadtcreateandsendmipinfo";
// 广告作废
export const ADVFAIL_STOP_URL = prefixMeiju + "/advertisement/stopOnline";
// 广告列表查询
export const QUERY_ADV_URL = prefixMeiju + "/advertisement/getAd";
export const GET_AD_LIST = prefixMeiju + "/advertisement/getAdList";
// 广告列表排序
export const QUERY_ADV_ORDER_URL = prefixMeiju + "/advertisement/getAdByWeight";
// 获取广告详情
export const GET_ADV_DETAIL_URL = prefixMeiju + "/advertisement/getDetail";

// http://10.18.45.89:8089/cmms/#/advertisement 广告分析
// http://10.18.45.89:8089/cmms/#/push 推送分析
// http://10.18.45.89:8089/cmms/#/invitation 邀请活动
// http://10.18.45.89:8089/cmms/#/draw 抽奖活动
// http://10.18.45.89:8089/cmms/#/detailcenter 活动详情

// 推送分析iframe的src地址
export const PUSH_ANALYSIS_URL =
  process.env.ENV_CONFIG === "prod"
    ? "http://iotbigdata.midea.com:10011/cmms/#/push"
    : ""; // 推送分析

// 广告分析iframe的src地址
export const ADVERTISEMENT_ANALYSIS_URL =
  process.env.ENV_CONFIG === "prod"
    ? "http://iotbigdata.midea.com:10011/cmms/#/advertisement"
    : ""; // 广告分析

// 页面分析iframe的src地址
export const PAGE_ANALYSIS_URL = process.env.ENV_CONFIG === "prod" ? "" : ""; // 页面分析

// 页面管理-模板
export const PAGE_GET_TEMPLATE_LIST =
  prefixMeiju + "/pageManagement/template/list";

// 页面管理-组件查询
export const PAGE_GET_ASSEMBLY_LIST =
  prefixMeiju + "/pageManagement/assembly/list";

// 页面管理-新增
export const PAGE_SAVE = prefixMeiju + "/pageManagement/save";

// 页面管理-修改
export const PAGE_UPDATE = prefixMeiju + "/pageManagement/update";

// 页面管理-查询
export const PAGE_LIST = prefixMeiju + "/pageManagement/list";

// 页面管理-操作
export const PAGE_OPERATE = prefixMeiju + "/pageManagement/operate";
// 复制
export const PAGE_COPY = prefixMeiju + "/pageManagement/copy";
// 作废
export const PAGE_INVALID = prefixMeiju + "/pageManagement/invalid";
// 删除
export const PAGE_DELETE = prefixMeiju + "/pageManagement/delete";
// 发布
export const PAGE_PUBLISH = prefixMeiju + "/pageManagement/publish";
// 取消发布
export const PAGE_CANCEL_PUBLISHED =
  prefixMeiju + "/pageManagement/cancelPublished";
// 定时发布
export const PAGE_SCHEDULED_PUBLISH =
  prefixMeiju + "/pageManagement/scheduledPublish";
// 编辑页 置为草稿状态
export const PAGE_DRAFT = prefixMeiju + "/pageManagement/draft";
// 编辑页 提审
export const PAGE_AUDIT = prefixMeiju + "/pageManagement/audit";
// 编辑页发布
export const PAGE_PUBLISH_EDIT = prefixMeiju + "/pageManagement/publishByEdit";
// 发布前-存在冲突的产品型号
export const GET_PUBLISH_PAGE_BY_PRODUCT =
  prefixMeiju + "/pageManagement/getPublishPageByProduct";
// 编辑页取消发布
export const PAGE_CANCEL_PUBLISHED_EDIT =
  prefixMeiju + "/pageManagement/cancelPublishedByEdit";
// 编辑页定时发布
export const PAGE_SCHEDULED_PUBLISH_EDIT =
  prefixMeiju + "/pageManagement/scheduledPublishByEdit";

// 页面管理-审核详情
export const CHECK_DETAIL = prefixMeiju + "/pageManagement/auditDetails";

// 页面管理-查询商品类别
export const PAGE_GET_CATEGORY_LIST =
  prefixMeiju + "/dcp-api/product/category/list";

// 页面管理-查询商品列表
export const PAGE_GET_PRODUCT_LIST = prefixMeiju + "/dcp-api/product/list";

// 页面管理-文章类别
export const PAGE_GET_ARTICLE_LIST =
  prefixMeiju + "/dcp-api/article/category/list";

// 页面管理-查看
export const PAGE_DETAIL = prefixMeiju + "/pageManagement/details";

// 页面管理-查看
export const GET_DCP_BRAND = prefixMeiju + "/dcp-api/brand/list";

// 页面管理-查看
export const PAGE_GET_ARTICLE_DETAL = prefixMeiju + "/dcp-api/article/list";
// 页面管理-文章推荐
export const ARTICLE_RECOMMENDED =
  prefixMeiju + "/dcp-api/articleRecommended/list";

// 页面管理-图文导航
export const PAGE_GET_NAV_LIST =
  prefixMeiju + "/pageManagement/graphicNavigation/list";

// 页面管理-查询用户品类
export const USER_CATEGORY_LIST =
  prefixMeiju + "/dcp-api/user/product/category/list";

// 页面管理-dcp精选文章
export const DCP_ARTICLE_LIST = prefixMeiju + "/dcp-api/featured/articles";
// 页面管理-dcp专题列表
export const DCP_SPECIAL_TOPIC_LIST =
  prefixMeiju + "/dcp-api/specialTopic/list";
// 页面管理-dcp专题文章列表
export const DCP_TOPIC_ARTICLE_LIST =
  prefixMeiju + "/dcp-api/specialTopic/articles/list";

// 页面管理-dcp虚拟账号
export const DCP_ACCOUNT_LIST = prefixMeiju + "/dcp-api/accounts";
// 页面管理-dcp事业部
export const DCP_DEPARTMENT_LIST = prefixMeiju + "/dcp-api/departments";
